import { AllowedReducer } from '@leverege/api-redux';
import { AbstractItemDelegate } from '@leverege/molten/data-source';
import { History, RoutesUtil } from '@leverege/molten/routes';
import { GlobalState } from '@leverege/ui-redux';
import FotaApi from "../api/FotaApi.js";
import FotaReducer from "../reducer/FotaReducer.js";
export default class AbstractFotaItemDelegate extends AbstractItemDelegate {
  constructor(options) {
    super(options);
    const {
      match,
      relationship,
      id
    } = options;
    this.id = id;
    this.options = options;
    this.match = match;
    this.relationship = relationship;
    this.api = new FotaApi({
      relationship
    });
  }
  parent() {
    return null;
  }
  getInterfaceUrl() {
    return this.relationship.ref;
  }
  getUrl() {
    return RoutesUtil.resolve(this.relationship.urlPath, this.match);
  }
  getResourceId(forFotaReducer, opts) {
    const path = `${this.relationship.refPath.slice(1)}/${this.id}`;
    return forFotaReducer ? `${path}$${opts?.queryName || 'default'}` : path;
  }
  getParentListResourceId(forFotaReducer, opts) {
    const path = this.relationship.refPath.slice(1);
    return forFotaReducer ? `${path}$${opts?.queryName || 'default'}` : path;
  }
  getApi() {
    console.warn('AbstractFotaItemDelegate.getApi: unimplemented');
  }
  requestCanGet() {
    return this.getApi().canGet(this.id);
  }
  get(opts, extra) {
    return this.getApi().get(this.id, {
      query: opts
    }, extra);
  }
  requestCanUpdate(patch, options) {
    return this.getApi().canUpdate(this.id, patch, options);
  }
  update(patch, options, extra) {
    return this.getApi().update(this.id, patch, options, extra);
  }
  requestCanDelete(deleteBody, options) {
    return this.getApi().canDelete(this.id, deleteBody, options);
  }
  delete(deleteBody, options, extra) {
    return this.getApi().delete(this.id, deleteBody, options, extra);
  }

  // utility

  goTo() {
    return History.push(this.getUrl());
  }
  isGotoAllowed() {
    return true;
  }

  // access

  getItem(state = GlobalState.get(), opts) {
    return FotaReducer.get(state, this.getResourceId(true, opts))?.items?.[0] || FotaReducer.get(state, this.getParentListResourceId(true, opts))?.items?.find(i => i.id === this.id);
  }
  getStatus(state = GlobalState.get(), opts) {
    return FotaReducer.getStatus(state, this.getResourceId(true, opts));
  }
  isLoading(state = GlobalState.get(), opts) {
    return FotaReducer.getStatus(state, this.getResourceId(true, opts)) === FotaReducer.LOADING;
  }
  isDone(state = GlobalState.get(), opts) {
    return FotaReducer.getStatus(state, this.getResourceId(true, opts)) !== FotaReducer.LOADING;
  }
  canGet(state = GlobalState.get()) {
    return AllowedReducer.get(state, this.getResourceId())?.get;
  }
  canUpdate(state = GlobalState.get()) {
    return AllowedReducer.get(state, this.getResourceId())?.update;
  }
  canDelete(state = GlobalState.get()) {
    return AllowedReducer.get(state, this.getResourceId())?.delete;
  }
  requestCanCreate() {
    return {
      type: 'noop'
    };
  }
  canCreate() {
    return null;
  }
}